import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Alert, Space } from '~/components';
import Button from '~/components/Button';
import ApplicationCommonErrors from '~/components/views/ApplicationCommonErrors';
import { useApplyCustomPricingIsLoading } from '~/controllers/pricing';
import {
  useGetApplication,
  useIsAgreeWaringMessage,
  useIsAgreeWithServicesTermsAndConditions,
  useIsAtLeastOneServiceSelected,
  useSaveStepIsLoading,
  useTotalPriceVisible,
} from '~/controllers/wizard';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import { isAgent } from '~/utils/getDecodedJwt';
import { isReadOnly } from '~/utils/isReadOnly';
import { servicesFormName } from './SelectServices';

const ServicesRightContent = (props: any) => {
  const { t } = useTranslation();
  const [agree, setAgree] = useIsAgreeWithServicesTermsAndConditions();
  const [isSaving] = useSaveStepIsLoading();

  const [, setTotalPriceModalVisible] = useTotalPriceVisible();
  const [isLoadingCustomPricing] = useApplyCustomPricingIsLoading();
  const [selectedAtLeastOne] = useIsAtLeastOneServiceSelected();
  const applicationQuery = useGetApplication();
  const uneditableStep = isReadOnly(applicationQuery.data);
  useEffect(() => {
    setAgree(true);
  }, [setAgree]);

  return (
    <Container className="ServicesRightContent">
      <Space className="ServicesRightContent-BottomSpace" direction="vertical" size={24}>
        <ApplicationCommonErrors />
        {isAgent() && (
          <Button
            id="savePricingButton"
            htmlType="submit"
            form={APPLY_CUSTOM_PRICING_FORM}
            loading={isSaving || isLoadingCustomPricing}
            type="default"
            block
            disabled={uneditableStep || !selectedAtLeastOne}
          >
            {t('Save')}
          </Button>
        )}

        <WizardContinueButton
            id="WizardContinueButton"
            isPriceLoading={isLoadingCustomPricing}
            disabled={!selectedAtLeastOne}
            formName={agree ? servicesFormName : undefined}
            onClick={() => {
              if (!agree) {
                setTotalPriceModalVisible(true);
              }
            }}
          >
            {t('Confirm')}
          </WizardContinueButton>
      </Space>
    </Container>
  );
};

export const APPLY_CUSTOM_PRICING_FORM = 'applyCustomPricingForm';

const Container = styled.div`
  #servicesContinueButton {
    margin-top: 0 !important;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  .ServicesRightContent-TermsCheckbox {
    margin-top: 48px;
    margin-bottom: 24px;
  }
`;

export default ServicesRightContent;
